export function getItemsFromLocationTypes(types: string[], addDefaults: boolean = true): { id: string; label: string }[] {
    let output: { id: string; label: string }[] = types.map(type => {
        return { id: type, label: type };
    });
    if (addDefaults) {
        if (!output.find(item => item.id === 'collection')) {
            output.push({ id: 'collection', label: 'collection' });
        }
        if (!output.find(item => item.id === 'delivery')) {
            output.push({ id: 'delivery', label: 'delivery' });
        }
    }
    return output;
}
